export const socialLinks = {
  rexmonster: {
    instagram: true,
    facebook: true,
    linkedin: true,
    twitter: true,
    youtube: false,
  },
  monstergulf: {
    instagram: false,
    facebook: true,
    linkedin: false,
    twitter: true,
    youtube: true,
  },
  monstersingapore: {
    instagram: false,
    facebook: true,
    linkedin: false,
    twitter: true,
    youtube: true,
  },
  monsterthailand: {
    instagram: false,
    facebook: false,
    linkedin: false,
    twitter: false,
    youtube: false,
  },
  monsterphilippines: {
    instagram: false,
    facebook: true,
    linkedin: false,
    twitter: true,
    youtube: true,
  },
  monstervietnam: {
    instagram: false,
    facebook: false,
    linkedin: false,
    twitter: false,
    youtube: false,
  },
  monstermalaysia: {
    instagram: false,
    facebook: true,
    linkedin: false,
    twitter: true,
    youtube: true,
  },
  monsterindonesia: {
    instagram: false,
    facebook: false,
    linkedin: false,
    twitter: false,
    youtube: false,
  },
  monsterhongkong: {
    instagram: false,
    facebook: true,
    linkedin: false,
    twitter: true,
    youtube: true,
  },
};
